<script lang="ts" setup>
import { UiAvatar } from '@shared/ui';
import type { UserAvatarProps } from './types';
import { useUserStore } from '~/app/modules/auth/stores/UserStore';

const runtimeConfig = useRuntimeConfig();

withDefaults(defineProps<UserAvatarProps>(), {
  tag: 'span',
  size: 'md',
});

const userStore = useUserStore();
const imgUrlPrefix = runtimeConfig.public.imgUrlPrefix;
</script>

<template>
  <UiAvatar
    v-if="userStore.currentAvatar"
    :src="`${imgUrlPrefix}/${userStore.currentAvatar}`"
    :alt="userStore.displayName"
    :size="size"
    :tag="tag"
  />
</template>
